import { Loader2 } from 'lucide-react';
import React, { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import aegisLogo from '../../assets/aegis-verify-logo.jpeg';
import { useAppState } from '../../context/AppStateContext';
import { ui } from '../../styles/ui';

export const LoginScreen = () => {
  const { login, error, loading, isLoggedIn, currentUser } = useAppState();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  if (isLoggedIn && currentUser) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    const result = await login(email, password);
    if (result.success) {
      navigate('/admin/dashboard', { replace: true });
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center p-4">
      <div className="w-full max-w-sm bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl shadow-sm p-8">
        <div className="text-center mb-6">
          <img src={aegisLogo} alt="Aegis Verify" className="mx-auto h-14 w-14 rounded-lg object-cover mb-3" />
          <h1 className="text-lg font-semibold text-gray-900 dark:text-white">Aegis Verify</h1>
          <p className="text-sm text-gray-500 dark:text-gray-400">Admin Portal</p>
        </div>

        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className={ui.label}>Email Address</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={ui.input}
              placeholder="admin@barcodeportal.com"
              required
            />
          </div>
          <div>
            <label className={ui.label}>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className={ui.input}
              placeholder="Enter your password"
              required
            />
          </div>
          {error && (
            <div className="p-2.5 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800/50 rounded-lg text-red-700 dark:text-red-300 text-sm">{error}</div>
          )}
          <button
            type="submit"
            disabled={loading}
            className="w-full py-2.5 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg font-medium text-sm transition-all duration-150 active:scale-[0.97] disabled:opacity-50 disabled:active:scale-100 disabled:cursor-not-allowed flex items-center justify-center gap-2"
          >
            {loading ? (
              <>
                <Loader2 className="h-4 w-4 animate-spin" />
                Signing In...
              </>
            ) : (
              'Sign In'
            )}
          </button>
        </form>

        <div className="mt-5 text-center">
          <p className="text-gray-500 dark:text-gray-400 text-sm mb-2">Don't have an account?</p>
          <button
            onClick={() => navigate('/register')}
            className="w-full py-2.5 bg-gray-100 hover:bg-gray-200 dark:bg-gray-700 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-200 rounded-lg font-medium text-sm transition-all duration-150 active:scale-[0.97]"
          >
            Register Now
          </button>
        </div>
      </div>
    </div>
  );
};
